import { render, staticRenderFns } from "./OtherDeliveryTable.vue?vue&type=template&id=07d33d55&scoped=true"
import script from "./OtherDeliveryTable.vue?vue&type=script&lang=js"
export * from "./OtherDeliveryTable.vue?vue&type=script&lang=js"
import style0 from "./OtherDeliveryTable.vue?vue&type=style&index=0&id=07d33d55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d33d55",
  null
  
)

export default component.exports